import {
  getFeatsOfType,
  getFeatsType,
  saveNewFeat,
} from "../../../api/feats-api";
import { Feat } from "../../../interfaces/feats";

export const loadFeatTypes = async () => {
  const types = await getFeatsType();
  return types;
};

export const loadFeatOfTypes = async (typ: string) => {
  const feats = await getFeatsOfType(typ);
  const sorted = feats.sort((a: any, b: any) => {
    return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
  });
  return sorted;
};

export const createFeat = async (charId: string, featId: string) => {
  return await saveNewFeat(charId, featId);
};
